import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from 'src/app/redux/store';
import { finalUrlsConfig } from 'src/configs/url.config';

export const loggerApiSlice = createApi({
  reducerPath: 'loggerApi',
  baseQuery: async (args, api, extraOptions) => {
    const dynamicBaseUrl = finalUrlsConfig().loggerServerBaseURL;

    const rawBaseQuery = fetchBaseQuery({
      baseUrl: dynamicBaseUrl,
      prepareHeaders: (headers, { getState }) => {
        const { token } = (getState() as RootState).user;
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
      },
    });
    return rawBaseQuery(args, api, extraOptions);
  },
  // baseQuery: fetchBaseQuery({
  //   baseUrl: finalUrlsConfig().loggerServerBaseURL,
  //   prepareHeaders: (headers, { getState }) => {
  //     const { token } = (getState() as RootState).user;
  //     if (token) {
  //       headers.set('Authorization', `Bearer ${token}`);
  //     }
  //     return headers;
  //   },
  // }),
  tagTypes: ['Logs'],
  endpoints: () => ({}),
});
